module.exports = __webpack_public_path__ + "static/summer-abccae7201981eaf1cfd83dfc3a45e01.png";